export const CURRENCY = {
  CAD: 'cad',
}

export const GENERAL_CURRENCY = CURRENCY.CAD
